import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule, _MatSlideToggleRequiredValidatorModule } from '@angular/material/slide-toggle';
import { PropertyStatsComponent } from "../property-stats/property-stats.component";
@Component({
    selector: 'app-property-information',
    standalone: true,
    templateUrl: './property-information.component.html',
    styleUrl: './property-information.component.scss',
    imports: [CommonModule, FormsModule, ReactiveFormsModule, MatCardModule, MatGridListModule, MatFormFieldModule, 
      MatChipsModule, MatStepperModule, MatInputModule, MatSelectModule, MatButtonModule, MatSlideToggleModule, _MatSlideToggleRequiredValidatorModule,
      PropertyStatsComponent]
})
export class PropertyInformationComponent {
  @Input() propertyData: any;
  tiles: Tile[] = [
    {text: 'Photo 1', cols: 1, rows: 1, color: 'lightblue'},
    {text: 'Photo 4', cols: 1, rows: 3, color: 'lightgreen'},
    {text: 'Map', cols: 1, rows: 3, color: 'lightpink'},
    {text: 'Stats', cols: 1, rows: 3, color: '#DDBDF1'},
    {text: 'Photo 2', cols: 1, rows: 1, color: '#DDBDF1'},
    {text: 'Photo 3', cols: 1, rows: 1, color: 'lightpink'},
    // {text: 'Seven', cols: 2, rows: 1, color: '#DDBDF1'},
  ];

  tiles2: Tile[] = [
    {text: 'Timeline', cols: 1, rows: 6, color: 'lightblue'},
    {text: 'ESG', cols: 1, rows: 1, color: 'lightgreen'},
    {text: 'Area Safety', cols: 1, rows: 1, color: 'lightpink'},
    {text: 'Charts', cols: 1, rows: 1, color: '#DDBDF1'},
    {text: 'Test 1', cols: 1, rows: 1, color: '#DDBDF1'},
    {text: 'Test 2', cols: 1, rows: 1, color: 'lightpink'},
    {text: 'Information', cols: 5, rows: 5, color: '#DDBDF1'},
  ];
  isChecked = true;
}

export interface Tile {
  color: string;
  cols: number;
  rows: number;
  text: string;
}
